import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {SessionService} from 'src/app/services/session.service';

@Component({
    selector: 'app-check-payment',
    templateUrl: './check-payment.component.html',
    styleUrls: ['./check-payment.component.scss']
})
export class CheckPaymentComponent implements OnChanges {
    @Input() canHideCounter = true;
    @Input() showQuantity = false;
    @Input() noCheck = false;
    @Input() item: any;
    @Input() checkTop: boolean;
    @Input() checkTopText = 'Cantidad:';
    @Input() roundedButtons = false;
    @Output() itemChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() quantityData: any;

    constructor(
        private sessionService: SessionService
    ) {
    }

    ngOnChanges(): void {
        if (this.item) {
            this.quantityData = this.item.quantity;
        }
    }

    toggleAdd(event): void {
        this.item.isAdd = event.checked;
        this.item.quantity = event.checked ? this.item.quantity : 1;
        this.quantityData = this.item.quantity;
        this.itemChange.emit(this.item);
    }

    modifyNumber(event): void {
        if (event) {
            this.item.quantity++;
        } else {
            if (this.noCheck) {
                if (this.item.quantity > 1) {
                    this.item.quantity--;
                }
            } else {
                if (this.item.quantity > 1) {
                    this.item.quantity--;
                }
            }
        }
        this.quantityData = this.item.quantity;
        this.itemChange.emit(this.item);
    }

    modifyQuantity(): void {
        if (this.quantityData) {
            this.item.quantity = parseInt(this.quantityData, 10);
        } else {
            this.quantityData = 1;
            this.item.quantity = this.quantityData;
        }
        if ( this.item.quantity === 0) {
            this.item.quantity = 1;
            this.item.isAdd = false;
        }
        this.quantityData = this.item.quantity;
        this.itemChange.emit(this.item);
    }

    isHide(): boolean {
        if (this.canHideCounter) {
            return this.item.isAdd;
        }
        return true;
    }

}
